import Image from "next/image"

type ProductThumbnailProps = {
  src?: string | null
  alt: string
  sizes: string
  imageClassName?: string
  containerClassName?: string
}

export default function ProductThumbnail({
  src,
  alt,
  sizes,
  imageClassName = "object-contain",
  containerClassName = "",
}: ProductThumbnailProps) {
  return (
    <div className={`relative bg-gray-50 ${containerClassName}`}>
      {src ? (
        <Image src={src} alt={alt} fill className={imageClassName} sizes={sizes} />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-gray-300 text-sm">
          No image
        </div>
      )}
    </div>
  )
}
